import cmsSettings from '../cmsSettings'
import { headerWithCtas, videoAsset } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  eyebrow,
  ${headerWithCtas.fragment('headingContent')},
  "textColor": coalesce(textColor, 'dough'),
  "verticalAlign": coalesce(verticalAlign, 'mid'),
  overlayOpacity,
  ${videoAsset.fragment('videoLoopDesktop')},
  ${videoAsset.fragment('videoLoopMobile')}
`

export const fragment = (name = 'dayInTheLifeVideo') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
